export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.wematch.team',
  //apiBaseUrl: '',
  googleAuthUrl: 'https://dev.wematch.team/bff/google-login',
  perimeterDevKey: 'EuP2Qv1HBjw7ZF3WNJpoTdKcIlnyYiR9',
};
